import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';

import { AppComponent } from './app.component';

import { UnderConstructionComponent } from './shared/common/index';

// Module Route Config for Lazy Loading..

const routes: Routes = [
    { path: '', redirectTo: 'home', pathMatch: 'full' },
    { path: 'home', loadChildren: './home/home.module#HomeModule' },
    { path: 'citizen', loadChildren: './citizen/citizen.module#CitizenModule' },
    { path: 'admin', loadChildren: './admin/admin.module#AdminModule' },
    { path: 'map', loadChildren: './map/map.module#MapModule' },
    { path: 'report', loadChildren: './report/report.module#ReportModule' },
    { path: 'services', loadChildren: './services/service.module#ServiceModule' },
    { path: 'permit', loadChildren: './permit/permit.module#PermitModule' },
    { path: 'payment', loadChildren: './payment/payment.module#PaymentModule' },
    { path: 'alert', loadChildren: './alert/alert.module#AlertModule' },
    { path: 'others', loadChildren:'./others/others.module#OthersModule' },
    { path: 'pawn', loadChildren: './pawn/pawn.module#PawnModule' },
    { path: 'underconstruction', component: UnderConstructionComponent },
    { path: 'citpermit', loadChildren: './citpermit/citpermit.module#CitpermitModule' },
    { path: '**', redirectTo: 'home' }
];

export const routing: ModuleWithProviders = RouterModule.forRoot(routes, { useHash: true });
//export const routing: ModuleWithProviders = RouterModule.forRoot(routes);



// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/app-routing.module.ts